import React from 'react';
import { Box, Button } from '@mui/material';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import InterveneToolbarIconButton from '../InterveneToolbarIconButton';
import useInterveneSx from '../../hooks/useInterveneSx';

export default function HeaderActions({
  showSessionToggle,
  canStartSession,
  canEndSession,
  onStartSession,
  onEndSession,
  onCall,
  callDisabled,
}) {
  const interveneSx = useInterveneSx();
  const headerAction = interveneSx.headerAction;
  const headerStyles = interveneSx.chatHeader;

  return (
    <Box sx={[headerAction.group, headerStyles.actions]}>
      {onCall ? (
        <Box sx={headerAction.iconTileGroup} role="group" aria-label="Chat actions">
          <InterveneToolbarIconButton
            title="Call"
            ariaLabel="Call customer"
            onClick={onCall}
            disabled={callDisabled}
            icon={<PhoneOutlinedIcon />}
          />
        </Box>
      ) : null}

      {showSessionToggle && (
        <Box sx={headerAction.stateGroup} role="group" aria-label="Intervene session">
          <Button
            color="inherit"
            disableElevation
            onClick={canStartSession ? onStartSession : undefined}
            disabled={!canStartSession}
            aria-pressed={canStartSession}
            sx={{
              ...headerAction.stateOption,
              ...(canStartSession ? headerAction.stateOptionActive : {}),
            }}
          >
            Start
          </Button>
          <Button
            color="inherit"
            disableElevation
            onClick={canEndSession ? onEndSession : undefined}
            disabled={!canEndSession}
            aria-pressed={canEndSession}
            sx={{
              ...headerAction.stateOption,
              ...(canEndSession ? headerAction.stateOptionActive : {}),
            }}
          >
            End
          </Button>
        </Box>
      )}
    </Box>
  );
}
